import { HighlightCard } from '@yleisradio/areena-types';
import React, { useEffect, useRef, useState } from 'react';
import { trackHighlightCardView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { getEntityIdForCard } from 'utils/card';

type Props = {
  card: HighlightCard;
  contentIndex: number;
  children?: React.ReactNode;
  viewUuid: string;
};

export const ViewableHighlightCard: React.FC<Props> = ({
  card,
  children,
  contentIndex,
  viewUuid,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isSent, setSent] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || isSent) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry || !entry.isIntersecting) return;

      trackHighlightCardView({
        contentIndex,
        imageId: card.image?.id,
        title: card.title,
        viewUuid,
        entityId: getEntityIdForCard(card),
        targetUri: card.pointer?.uri,
      });

      setSent(true);
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [card, contentIndex, isSent, viewUuid]);

  return <div ref={ref}>{children}</div>;
};
